import { useState } from 'react';
import { createPortal } from 'react-dom';
import { C } from '../styles/tokens.js';

const TAB_FILES = [
  { id: 'tf1', name: '전북과학교육원_제안서_v3.pptx', type: 'pptx', size: '38.2 MB', date: '2026.06.25', final: true,  uploader: '이팀장' },
  { id: 'tf2', name: '전북과학교육원_제안서_v2.pptx', type: 'pptx', size: '35.1 MB', date: '2026.06.20', final: false, uploader: '박대리' },
  { id: 'tf3', name: '전시연출_레퍼런스.pdf',         type: 'pdf',  size: '12.4 MB', date: '2026.06.22', final: false, uploader: '김과장' },
  { id: 'tf4', name: '공간배치도_r3.dwg',            type: 'dwg',  size: '8.0 MB',  date: '2026.06.24', final: true,  uploader: '최주임' },
  { id: 'tf5', name: '예산산출서_초안.xlsx',          type: 'xlsx', size: '1.2 MB',  date: '2026.06.27', final: false, uploader: '박대리' },
];

const ICONS = { pdf: '📄', pptx: '📊', dwg: '📐', xlsx: '📋', docx: '📝' };

export default function FilePickerModal({ onClose, onPick }) {
  const [q, setQ] = useState('');
  const filtered = TAB_FILES.filter(f => f.name.toLowerCase().includes(q.toLowerCase()));

  // createPortal로 document.body에 직접 렌더 - transform 부모 영향 제거
  return createPortal(
    <div onClick={onClose} onMouseDown={e => e.stopPropagation()}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}>
      <div onClick={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()}
        style={{ background: C.surface, borderRadius: 12, width: 520, padding: 20, border: `1px solid ${C.border}`, maxHeight: '80vh', display: 'flex', flexDirection: 'column', boxShadow: '0 24px 64px rgba(0,0,0,0.6)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <div style={{ fontSize: 15, color: C.text, fontWeight: 800 }}>📁 파일 탭에서 선택</div>
          <button onClick={onClose} style={{ background: 'transparent', border: 'none', color: C.dim, fontSize: 22, cursor: 'pointer' }}>×</button>
        </div>
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="파일명 검색..." autoFocus
          style={{ width: '100%', padding: '9px 12px', background: C.surface2, border: `1px solid ${C.border}`, borderRadius: 6, color: C.text, fontSize: 13, outline: 'none', marginBottom: 12 }} />
        <div style={{ overflowY: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: 4 }}>
          {filtered.length === 0 && <div style={{ padding: '20px 12px', color: C.dim, fontSize: 12, textAlign: 'center' }}>검색 결과 없음</div>}
          {filtered.map(f => (
            <div key={f.id} onClick={() => { onPick(f); onClose(); }}
              style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 12px', background: C.surface2, borderRadius: 8, cursor: 'pointer', border: `1px solid ${C.border}` }}
              onMouseEnter={e => e.currentTarget.style.borderColor = C.gold}
              onMouseLeave={e => e.currentTarget.style.borderColor = C.border}>
              <span style={{ fontSize: 22 }}>{ICONS[f.type] || '📁'}</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, color: C.text, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{f.name}</span>
                  {f.final && <span style={{ fontSize: 9, padding: '1px 6px', background: C.goldBg, color: C.gold, borderRadius: 3, fontWeight: 800 }}>FINAL</span>}
                </div>
                <div style={{ fontSize: 10, color: C.dim, marginTop: 2 }}>{f.uploader} · {f.size} · {f.date}</div>
              </div>
              <span style={{ color: C.gold, fontSize: 14 }}>›</span>
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
}

// 외부에서도 사용 가능하도록 TAB_FILES export
export { TAB_FILES };
